





























import Vue from "vue";

export default Vue.extend({
  props: {
    numberParam: {
      type: Object,
      default: Object,
    },
    numberKey: {
      type: String,
      default: String,
    },
    numberIndex: {
      type: Number,
      default: Number,
    },
    minValue: {
      type: Number,
      default: Number,
    },
    maxValue: {
      type: Number,
      default: Number,
    },
  },
  data() {
    return {
      CheckInput: "",
      checkType2: "",
      error: "",
      regexReal: new RegExp(/^([1-9]\d*|0)(\.\d+)?$/),
      regexcheck: new RegExp(/^(-?[0-9])+(.?[0-9]*)$/),
      regexInteger: new RegExp(/^-?[0-9]+$/),
    };
  },
  watch: {
    numberParam: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      if (this.numberKey === "false_ne") {
        this.CheckInput = this.numberParam[this.numberKey][this.numberIndex];
      }
      if (this.numberKey !== "false_ne") {
        this.checkType2 = this.numberParam[this.numberKey];
      }
    },
    SendNumber() {
      this.$emit("NumberEvent");
    },
    ChangeFalseNE(Argument: string) {
      if (!this.regexInteger.test(String(Argument))) {
        this.error = "整数を入力してください";
        this.$emit("hasError", false);
        if (this.numberIndex === 0) {
          this.numberParam[this.numberKey] = [
            null,
            this.numberParam[this.numberKey][1],
          ];
        }
        if (this.numberIndex === 1) {
          this.numberParam[this.numberKey] = [
            this.numberParam[this.numberKey][0],
            null,
          ];
        }
        return;
      }
      if (this.numberIndex === 0) {
        if (Number(Argument) > 25000000) {
          this.error = "25000000以下の値を指定してください";
          this.$emit("hasError", false);
          this.numberParam[this.numberKey] = [
            null,
            this.numberParam[this.numberKey][1],
          ];
          return;
        }
        if (Number(Argument) < -25000000) {
          this.error = "-25000000以上の値を指定してください";
          this.$emit("hasError", false);
          this.numberParam[this.numberKey] = [
            null,
            this.numberParam[this.numberKey][1],
          ];
          return;
        }
      }
      if (this.numberIndex === 1) {
        if (Number(Argument) > 50000000) {
          this.error = "50000000以下の値を指定してください";
          this.$emit("hasError", false);
          this.numberParam[this.numberKey] = [
            this.numberParam[this.numberKey][0],
            null,
          ];
          return;
        }
        if (Number(Argument) < -50000000) {
          this.error = "-50000000以上の値を指定してください";
          this.$emit("hasError", false);
          this.numberParam[this.numberKey] = [
            this.numberParam[this.numberKey][0],
            null,
          ];
          return;
        }
      }
      if (this.numberIndex === 0) {
        this.numberParam[this.numberKey] = [
          Number(Argument),
          this.numberParam[this.numberKey][1],
        ];
      }
      if (this.numberIndex === 1) {
        this.numberParam[this.numberKey] = [
          this.numberParam[this.numberKey][0],
          Number(Argument),
        ];
      }
      this.error = "";
      this.$emit("hasError", true);
    },
    CheckNumber(Argument: string) {
      if (
        this.numberKey === "b" ||
        this.numberKey === "rf" ||
        this.numberKey === "a"
      ) {
        this.numberParam.terr = "direct";
      }
      if (!this.regexcheck.test(String(Argument))) {
        this.error = "数字を入力してください";
        this.$emit("hasError", false);
        this.numberParam[this.numberKey] = null;
        return;
      }
      if (Number(Argument) > this.maxValue) {
        this.error = this.maxValue + "以下の値を指定してください";
        this.$emit("hasError", false);
        this.numberParam[this.numberKey] = null;
        return;
      }
      if (Number(Argument) < this.minValue) {
        this.error = this.minValue + "以上の値を指定してください";
        this.$emit("hasError", false);
        this.numberParam[this.numberKey] = null;
        return;
      }
      this.numberParam[this.numberKey] = Number(Argument);
      this.error = "";
      this.$emit("hasError", true);
    },
  },
});
